import {
  Box, Typography, Chip, Button, Divider, Avatar,
  IconButton, Card, CardContent,
} from "@mui/material";
import LinkedInIcon       from "@mui/icons-material/LinkedIn";
import GitHubIcon         from "@mui/icons-material/GitHub";
import InstagramIcon      from "@mui/icons-material/Instagram";
import TwitterIcon        from "@mui/icons-material/Twitter";
import WhatsAppIcon       from "@mui/icons-material/WhatsApp";
import RestaurantIcon     from "@mui/icons-material/Restaurant";
import SecurityIcon       from "@mui/icons-material/Security";
import SpeedIcon          from "@mui/icons-material/Speed";
import PhoneAndroidIcon   from "@mui/icons-material/PhoneAndroid";
import StorefrontIcon     from "@mui/icons-material/Storefront";
import LocalOfferIcon     from "@mui/icons-material/LocalOffer";
import FavoriteIcon       from "@mui/icons-material/Favorite";
import OpenInNewIcon        from "@mui/icons-material/OpenInNew";

// ── App features ──────────────────────────────────────────────────
const FEATURES = [
  { icon: <PhoneAndroidIcon sx={{ fontSize: 20, color: "#2e7d32" }} />, title: "Mobile First",        desc: "Designed for phones — fast, smooth, native feel",  bg: "#e8f5e9" },
  { icon: <WhatsAppIcon     sx={{ fontSize: 20, color: "#25D366" }} />, title: "WhatsApp Orders",     desc: "Orders go directly to restaurant via WhatsApp",       bg: "#f0fff4" },
  { icon: <LocalOfferIcon   sx={{ fontSize: 20, color: "#e65100" }} />, title: "Smart Offers",        desc: "BOGO, category & promo code discounts auto-applied",  bg: "#fff3e0" },
  { icon: <StorefrontIcon   sx={{ fontSize: 20, color: "#1565c0" }} />, title: "Multi-Restaurant",    desc: "Any restaurant can get their own branded menu page",  bg: "#e3f2fd" },
  { icon: <SpeedIcon        sx={{ fontSize: 20, color: "#7b1fa2" }} />, title: "Lightning Fast",      desc: "Optimised for low-bandwidth mobile networks",         bg: "#f3e5f5" },
  { icon: <SecurityIcon     sx={{ fontSize: 20, color: "#c62828" }} />, title: "No Account Needed",   desc: "Browse, order and pay — zero signup required",        bg: "#ffebee" },
];

// ── Tech stack ────────────────────────────────────────────────────
const TECH_STACK = [
  { label: "React",       color: "#61DAFB", bg: "#e8f9fd" },
  { label: "Redux",       color: "#764ABC", bg: "#f0ebff" },
  { label: "Node.js",     color: "#339933", bg: "#e8f5e9" },
  { label: "MongoDB",     color: "#47A248", bg: "#edf7ed" },
  { label: "Cloudinary",  color: "#3448C5", bg: "#e8ecff" },
  { label: "MUI",         color: "#007FFF", bg: "#e6f2ff" },
  { label: "Express",     color: "#000000", bg: "#f5f5f5" },
  { label: "WhatsApp API",color: "#25D366", bg: "#f0fff4" },
];

// ── Version history ───────────────────────────────────────────────
const CHANGELOG = [
  { version: "v1.2.0", date: "Feb 2026",  label: "Latest", changes: "Smart offers system, BOGO & category discounts, banner carousel" },
  { version: "v1.1.0", date: "Jan 2026",  label: null,      changes: "Dine In / Takeaway / Delivery order types, promo codes" },
  { version: "v1.0.0", date: "Dec 2025",  label: "Launch",  changes: "Initial launch — menu, cart, WhatsApp ordering" },
];

// ══════════════════════════════════════════════════════════════════
const AboutPage = ({ onBack }) => {
  return (
    <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", pb: 4 }}>

      {/* Top bar handled by RestaurantLayout */}

      {/* ── Mini Hero ── */}
      <Box sx={{
        background: "linear-gradient(135deg, #1a237e 0%, #1565c0 50%, #0288d1 100%)",
        px: 2, pt: 3, pb: 4, textAlign: "center", position: "relative", overflow: "hidden",
      }}>
        {[{ w:100, h:100, t:"-25px", r:"-25px", o:0.07 }, { w:70, h:70, b:"-15px", l:"-15px", o:0.07 }].map((s, i) => (
          <Box key={i} sx={{ position:"absolute", width:s.w, height:s.h, borderRadius:"50%", bgcolor:"white", opacity:s.o, top:s.t, right:s.r, bottom:s.b, left:s.l }} />
        ))}
        <Box sx={{ width: 68, height: 68, borderRadius: 3.5, bgcolor: "white", mx: "auto", mb: 1.5, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 6px 24px rgba(0,0,0,0.22)", position: "relative", zIndex: 1 }}>
          <RestaurantIcon sx={{ fontSize: 38, color: "#2e7d32" }} />
        </Box>
        <Typography variant="h5" sx={{ color: "white", fontWeight: 900, fontSize: "1.4rem", letterSpacing: -0.5, position: "relative", zIndex: 1 }}>
          RestaurantWala
        </Typography>
        <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.8)", fontSize: "0.75rem", display: "block", mb: 1.2, position: "relative", zIndex: 1 }}>
          Smart Restaurant Management System
        </Typography>
        {/* <Box sx={{ display: "flex", gap: 0.8, justifyContent: "center", flexWrap: "wrap", position: "relative", zIndex: 1 }}>
          <Chip label="v1.2.0" size="small" sx={{ height: 20, fontSize: "0.62rem", fontWeight: 700, bgcolor: "rgba(255,255,255,0.2)", color: "white" }} />
          <Chip label="Free to use" size="small" sx={{ height: 20, fontSize: "0.62rem", fontWeight: 700, bgcolor: "rgba(255,255,255,0.2)", color: "white" }} />
          <Chip label="Made in India 🇮🇳" size="small" sx={{ height: 20, fontSize: "0.62rem", fontWeight: 700, bgcolor: "rgba(255,255,255,0.2)", color: "white" }} />
        </Box> */}
      </Box>

      {/* ── Our Story ── */}
      <Box sx={{ mx: 2, mt: 2, mb: 2 }}>
        <Box sx={{ bgcolor: "white", borderRadius: 3, p: 2.5, border: "1px solid #f0f0f0", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.2 }}>
            {/* <FavoriteIcon sx={{ fontSize: 18, color: "#e53935" }} /> */}
            <Typography variant="subtitle1" sx={{ fontWeight: 800, fontSize: "0.95rem" }}>Our Story</Typography>
          </Box>
          <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7, fontSize: "0.82rem" }}>
           RestaurantWala was founded in 2026 with a simple mission: to make restaurant management easy, affordable, and digital.
          </Typography>
          <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.7, fontSize: "0.82rem", mt: 1 }}>
            We saw that small and medium restaurants struggled with digitization due to high costs and complexity. We built RestaurantWala to solve this - affordable, easy to use, and powerful enough to handle all restaurant needs.
          </Typography>
        </Box>
      </Box>

      <Box sx={{ px: 2, display: "flex", flexDirection: "column", gap: 2 }}>

        {/* ── Features Grid ── */}
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, fontSize: "0.95rem", mb: 1.2 }}>
           What Makes Us Different
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
            {FEATURES.map((f, i) => (
              <Box key={i} sx={{ bgcolor: "white", borderRadius: 2.5, p: 1.5, border: "1px solid #f0f0f0", display: "flex", flexDirection: "column", gap: 0.8 }}>
                <Box sx={{ width: 36, height: 36, borderRadius: 2, bgcolor: f.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {f.icon}
                </Box>
                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: "0.78rem", color: "#1a1a1a", lineHeight: 1.3 }}>{f.title}</Typography>
                <Typography variant="caption" sx={{ color: "#888", fontSize: "0.68rem", lineHeight: 1.4 }}>{f.desc}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* ── Tech Stack ── */}
        {/* <Box sx={{ bgcolor: "white", borderRadius: 2.5, p: 2, border: "1px solid #f0f0f0" }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: "0.85rem", mb: 1.2, color: "#333" }}>
            🛠️ Built With
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.7 }}>
            {TECH_STACK.map((t) => (
              <Chip
                key={t.label}
                label={t.label}
                size="small"
                sx={{
                  height: 24, fontSize: "0.7rem", fontWeight: 700,
                  bgcolor: t.bg, color: t.color,
                  border: `1px solid ${t.color}30`,
                }}
              />
            ))}
          </Box>
        </Box> */}

        {/* ── Version History ── */}
        {/* <Box sx={{ bgcolor: "white", borderRadius: 2.5, p: 2, border: "1px solid #f0f0f0" }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: "0.85rem", mb: 1.5, color: "#333" }}>
            🗓️ Version History
          </Typography>
          {CHANGELOG.map((log, i) => (
            <Box key={i}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", py: 1 }}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 0.3 }}>
                  <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: i === 0 ? "#2e7d32" : "#d0d0d0", flexShrink: 0 }} />
                  {i < CHANGELOG.length - 1 && <Box sx={{ width: 1.5, flex: 1, bgcolor: "#f0f0f0", mt: 0.5 }} />}
                </Box>
                <Box sx={{ flex: 1, pb: i < CHANGELOG.length - 1 ? 1 : 0 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, mb: 0.3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 800, fontSize: "0.82rem", color: "#1a1a1a" }}>{log.version}</Typography>
                    {log.label && (
                      <Chip label={log.label} size="small" sx={{ height: 16, fontSize: "0.58rem", fontWeight: 700,
                        bgcolor: log.label === "Latest" ? "#e8f5e9" : "#f5f5f5",
                        color:   log.label === "Latest" ? "#2e7d32" : "#888" }} />
                    )}
                    <Typography variant="caption" sx={{ color: "#aaa", fontSize: "0.68rem", ml: "auto" }}>{log.date}</Typography>
                  </Box>
                  <Typography variant="caption" sx={{ color: "#666", fontSize: "0.75rem", lineHeight: 1.4 }}>{log.changes}</Typography>
                </Box>
              </Box>
              {i < CHANGELOG.length - 1 && <Divider sx={{ opacity: 0.4 }} />}
            </Box>
          ))}
        </Box> */}

        {/* ── Social & Links ── */}
        <Box sx={{ bgcolor: "white", borderRadius: 2.5, p: 2, border: "1px solid #f0f0f0" }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: "0.85rem", mb: 1.5, color: "#333" }}>
            🔗 Connect With Us
          </Typography>
          <Box sx={{ display: "flex", gap: 1, mb: 1.5 }}>
            {[
              // { icon: <GitHubIcon />,    color: "#333",    label: "GitHub",    url: "https://github.com" },
              { icon: <LinkedInIcon />,  color: "#0077b5", label: "LinkedIn",  url: "https://linkedin.com" },
              // { icon: <TwitterIcon />,   color: "#1DA1F2", label: "Twitter",   url: "https://twitter.com" },
              { icon: <InstagramIcon />, color: "#E1306C", label: "Instagram", url: "https://instagram.com" },
            ].map((s) => (
              <IconButton key={s.label} size="small"
                onClick={() => window.open(s.url, "_blank", "noopener")}
                sx={{ bgcolor: "#f5f5f5", color: s.color, width: 38, height: 38, "&:hover": { bgcolor: "#ebebeb" } }}>
                {s.icon}
              </IconButton>
            ))}
          </Box>
          <Button fullWidth variant="outlined" endIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
            onClick={() => window.open("https://restaurantwala.in/", "_blank", "noopener")}
            sx={{ borderRadius: 2, borderColor: "#e0e0e0", color: "#555", textTransform: "none", fontWeight: 600, fontSize: "0.82rem", "&:hover": { borderColor: "#1565c0", color: "#1565c0" } }}>
            Visit Website
          </Button>
        </Box>

        {/* ── Legal ── */}
        {/* <Box sx={{ bgcolor: "white", borderRadius: 2.5, p: 2, border: "1px solid #f0f0f0" }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: "0.85rem", mb: 1, color: "#333" }}>📄 Legal</Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8 }}>
            {["Privacy Policy", "Terms of Service", "Cookie Policy"].map((item) => (
              <Box key={item} onClick={() => {}}
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", py: 0.3, "&:hover": { "& .link-text": { color: "#1565c0" } } }}>
                <Typography className="link-text" variant="body2" sx={{ fontSize: "0.82rem", color: "#555", transition: "color 0.15s" }}>
                  {item}
                </Typography>
                <OpenInNewIcon sx={{ fontSize: 14, color: "#bbb" }} />
              </Box>
            ))}
          </Box>
        </Box> */}

        {/* ── Footer ── */}
        {/* <Box sx={{ textAlign: "center", py: 1 }}>
          <Typography variant="caption" sx={{ color: "#bbb", fontSize: "0.72rem", display: "block" }}>
            RestaurantWala v1.2.0 · © 2026 All rights reserved
          </Typography>
          <Typography variant="caption" sx={{ color: "#ccc", fontSize: "0.68rem", display: "flex", alignItems: "center", justifyContent: "center", gap: 0.4, mt: 0.3 }}>
            Made with <FavoriteIcon sx={{ fontSize: 11, color: "#e53935" }} /> in India
          </Typography>
        </Box> */}
      </Box>
    </Box>
  );
};

export default AboutPage;